var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { required, SimpleForm, TextInput, useTranslate } from 'react-admin';
import { makeStyles, Typography } from '@material-ui/core';
import { ResetPasswordToolbar } from './ResetPasswordToolbar';
export const ResetPasswordForm = props => {
    const { onSubmit = () => { }, toolbarProps } = props, rest = __rest(props, ["onSubmit", "toolbarProps"]);
    const classes = useStyles(rest);
    const translate = useTranslate();
    return (React.createElement("div", { className: classes.root },
        React.createElement(Typography, { variant: "subtitle1", color: "textSecondary", className: classes.instructions }, translate('apihub.reset_password.form_details.instructions')),
        React.createElement(Typography, { variant: "subtitle2", color: "textSecondary", className: classes.description, gutterBottom: true }, translate('apihub.reset_password.form_details.description')),
        React.createElement(SimpleForm, Object.assign({ className: classes.form, save: onSubmit, toolbar: React.createElement(ResetPasswordToolbar, Object.assign({}, toolbarProps)) }, rest),
            React.createElement(TextInput, { source: "username", type: "text", label: "apihub.reset_password.fields.username", variant: "filled", fullWidth: true, validate: required(), autoFocus: true }))));
};
const useStyles = makeStyles(theme => ({
    root: {},
    instructions: {
        paddingTop: theme.spacing(2),
        fontSize: theme.typography.fontSize,
        fontWeight: theme.typography.fontWeightBold,
    },
    description: {
        paddingBottom: theme.spacing(2),
    },
    form: {
        '& >:first-child': {
            padding: 0,
        },
    },
}), {
    name: 'Layer7ResetPasswordForm',
});
//# sourceMappingURL=ResetPasswordForm.js.map